<template>
    <div class="form-group">
        <select
        v-model="defaultMT4Account"
        class="select form-control"
        id="select"
        name="select"
        v-on:change="onSetDefaultMt4Account()"
        >
        <option
            v-for="mt4 in mT4Accounts"
            :value="mt4"
            v-show="!mt4.mustBeCreated"
        >{{mt4.login}}</option>
        </select>
    </div>
</template>

<script>
  import EventBus from '../event-bus';
  import { getUserRecord } from '../services/MT4Service';
  import AccountService from '@/services/AccountService';

  let accountService = new AccountService();

  export default {
    name: 'mt4-account-list',
    data: function () {
      return {
        mT4Accounts: [],
        isLoading: true,
        defaultMT4Account:{}
      };
    },
    created() {
        EventBus.$on('onUpdateComponent', (r)=>{
            this.populateComponent();
        });
        this.populateComponent();
    },
    methods: {
      populateComponent() {
          this.isLoading = true;
          accountService.getMT4Accounts().then(r => {
              this.mT4Accounts = r.data;
              this.mT4Accounts.forEach(element => {
                  if (element.default) {
                      this.defaultMT4Account = element;
                  }
              });
              this.isLoading = false;
          });
       
      },
      onSetDefaultMt4Account(){
          EventBus.$emit('onSetDefaultMt4Account', this.defaultMT4Account);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Mt4AccountList.vue